module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_null@2x.bfc566d3.png";